import { Box, Typography, TypographyProps } from "@mui/material";
import React from "react";
import styled from "@emotion/styled";
import { GainLossPercents } from "@components";

export const GainLossPercentsStyled = styled(GainLossPercents)`
  margin-left: ${({ theme }) => theme.spacing(3)};
`;

export const InvestmentsTableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  margin-top: ${({ theme }) => theme.spacing(10)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: ${({ theme }) => theme.spacing(4)};
    margin-bottom: ${({ theme }) => theme.spacing(4)};
    padding: ${({ theme }) => theme.spacing(0)};
  }
`;

export const InvestmentsTableSummaryWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.palette.background.paper};

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;

export const GainLossTypographyBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    justify-content: flex-end;
    flex-wrap: wrap;
    width: auto;
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;

export const MarketValueContentBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export interface SummaryItemProps {
  label: string;
  labelVariant?: TypographyProps["variant"];
  children: React.ReactNode;
}

export const SummaryItem = ({
  label,
  labelVariant = "body4",
  children,
}: SummaryItemProps) => (
  <Box display="flex" flexDirection="column" sx={{ gap: 0.5 }}>
    <Typography color="textSecondary" variant={labelVariant}>
      {label}
    </Typography>
    {children}
  </Box>
);
